<div [formGroup]="parentForm">
	<table
		mat-table
		class="ob-table ob-table-plain no-link-decoration"
		aria-label="table"
		matSort
		[dataSource]="dataSource"
		[formArrayName]="controlName"
	>
		<ng-container [matColumnDef]="COLUMN_ACTIONS">
			<th mat-header-cell *matHeaderCellDef>
				<div class="action-wrapper">
					<div class="action-button">
						<button
							id="{{ controlName + '-add-row' }}"
							obButton="secondary"
							mat-icon-button
							(click)="onAddRow()"
							[disabled]="!canAdd()"
							matTooltip="{{ 'i18n.tooltip.addrow' | translate }}"
							type="button"
						>
							<mat-icon svgIcon="plus" class="ob-icon"></mat-icon>
						</button>
					</div>
				</div>
			</th>
			<td mat-cell *matCellDef="let row; let i = index">
				<div class="action-wrapper">
					@if (isRowEditMode(i)) {
						<div class="action-button">
							<button
								id="{{ controlName + '-discard-row' + i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onDiscard()"
								[disabled]="hasSelectedRows()"
								matTooltip="{{ 'i18n.tooltip.discard' | translate }}"
								type="button"
							>
								<mat-icon svgIcon="xmark" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
					@if (isRowEditMode(i)) {
						<div class="action-button">
							<button
								id="{{ controlName + '-save-row' + i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onSave()"
								[disabled]="!canSave(i)"
								matTooltip="{{ 'i18n.tooltip.save' | translate }}"
								type="button"
							>
								<mat-icon svgIcon="checkmark" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
					@if (canEdit()) {
						<div class="action-button">
							<button
								id="{{ controlName + '-edit-row' + i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onEditRow(i)"
								[disabled]="hasSelectedRows()"
								matTooltip="{{ 'i18n.tooltip.edit' | translate }}"
								type="button"
							>
								<mat-icon svgIcon="pencil" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
					@if (canRemove()) {
						<div class="action-button">
							<button
								id="{{ controlName + '-remove-row' + i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onRemoveRow(i)"
								[disabled]="hasSelectedRows()"
								matTooltip="{{ 'i18n.button.remove.tooltip' | translate }}"
								type="button"
							>
								<mat-icon svgIcon="delete" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
				</div>
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_AGENT">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.agent" | translate }}
			</th>
			<td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" [title]="COLUMN_AGENT">
				@if (isRowEditMode(i)) {
					<mat-form-field>
						<mat-label>{{ "i18n.property.agent" | translate }}</mat-label>
						<input
							id="{{ controlName + '-input-agent' + i }}"
							type="text"
							matInput
							[formControl]="filteredAgentsControl"
							formControlName="agent"
							[matAutocomplete]="auto"
							(change)="type(element, $event, COLUMN_AGENT)"
						/>
						<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayValue">
							@for (agent of filteredAgents$ | async; track agent; let ii = $index) {
								<mat-option [value]="agent" (onSelectionChange)="type(element, agent, COLUMN_AGENT)" id="{{ controlName + '-option-agent' + ii }}">
									{{ agent?.name | fallback: currentLanguage }}
								</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
				} @else {
					<span>{{ getAgent(element.agent)?.name | fallback: currentLanguage }}</span>
				}
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_HAD_ROLE">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.had_role" | translate }}
			</th>
			<td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" [title]="COLUMN_HAD_ROLE">
				@if (isRowEditMode(i)) {
					<mat-form-field>
						<mat-label>{{ "i18n.property.had_role" | translate }}</mat-label>
						<mat-select
							id="{{ controlName + '-hadRole' }}"
							formControlName="hadRole"
							(selectionChange)="type(element, $event.value, COLUMN_HAD_ROLE)"
							[compareWith]="compareType"
						>
							@for (item of attributionRole$ | async; track item; let iii = $index) {
								<mat-option [value]="item" (onSelectionChange)="type(element, item, COLUMN_HAD_ROLE)" id="{{ controlName + 'option-hadRole' + iii }}">
									{{ item?.name | fallback: currentLanguage }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				} @else {
					<span>{{ element.hadRole.name | fallback: currentLanguage }}</span>
				}
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns"></tr>
	</table>

	<div class="table-info-box">
		<app-infobox-no-content [datasource]="dataSource.data"></app-infobox-no-content>
	</div>
</div>
